import { computed, Ref, WritableComputedRef } from "vue";
import { FormFields, FormParams } from "@/domains/app/forms";
import { Aim, useAim } from "./aims";

export type AimFormState = {
    formArgs: FormParams;
    data: Ref<Aim | null>;
};

/**
 * Create form state descibing how to structure form with its configuration
 *
 * @param id id of the aim in the form
 * @returns a form state
 */
export function useAimForm(id?: number): AimFormState {
    const { data: aim, save, del, apiErrors } = useAim(id);

    const fields = getFields(aim);

    const formArgs: FormParams = {
        title: "Création d'une visée",
        driver: {
            submit: save,
        },
        fields,
        getErrors: () => apiErrors,
    };

    // If Edition mode
    if (id !== undefined && id >= 0) {
        formArgs.title = "Edition d'une visée";
        formArgs.driver.delete = del;
    }

    const formState: AimFormState = {
        formArgs,
        data: aim,
    };

    return formState;
}

/**
 * Map aim props to form fields
 *
 * @param aim aim state
 * @returns form fields
 */
function getFields(aim: Ref<Aim | null>): FormFields {
    const labelState: WritableComputedRef<string> = computed<string>({
        get: () => (aim.value ? aim.value.label : ""),
        set: (val: string) => {
            if (aim.value) aim.value.label = val;
        },
    });

    return [
        {
            label: "Label",
            type: "text",
            name: "label",
            getState: () => labelState,
        },
    ];
}
